import { useFormInputState } from 'hooks';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Button,
  ErrorMessage,
  LabeledInput,
  Spinner,
  Txt,
  FlexContainer,
  AgreePolicyBlock,
} from 'components';
import { passwordField } from 'config/fieldsProps';
import { useAuthState } from 'state';
import styles from './AuthLogin.module.scss';

const initialState = () => ({
  emailAddress: '',
  password: '',
});

const getErrorMessage = (e) => {
  if (e.code) {
    switch (e.code) {
      case 'auth/wrong-password':
        return {
          title: 'The password is incorrect',
          // message:
          //   'Please make sure your password is correct before logging in. Or, reset your password using the button below, an email will be sent to: \\n\\n\\(email)',
          message:
            'Please make sure your password is correct before logging in.',
        };
      case 'auth/invalid-email':
        return {
          title: 'Email Incorrectly Formatted',
          message: 'Please check your email is valid and correctly formatted.',
        };
      case 'auth/user-not-found':
        return {
          title: 'User not found',
          message: "The email address isn't registered",
        };
      default:
        return {
          title: 'Unknown error',
          message: e.code,
        };
    }
  }

  return {
    title: '',
    message: e.message || e.toString(),
  };
};

/**
 * AuthLogin
 *
 * @return {JSX.Element}
 */
const AuthLogin = () => {
  const authState = useAuthState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [state, handleChange] = useFormInputState(initialState);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      const result = await authState.login(...Object.values(state));
      console.log(result);
    } catch (e) {
      setError(getErrorMessage(e));
      setIsLoading(false);
    }
    console.log(state);
  };

  return (
    <FlexContainer className={styles.Container} column gap justifyContentCenter>
      <Helmet title="Login" />
      <FlexContainer column gapHalf>
        <Txt xxxxx>Login</Txt>
        <Txt xx regular>
          Enter your login details, then tap continue.
        </Txt>
      </FlexContainer>
      <form onSubmit={handleSubmit} className={styles.Form}>
        <LabeledInput
          label="Email address"
          type="email"
          name="emailAddress"
          onChange={handleChange}
          value={state.emailAddress}
          disabled={isLoading}
          required
        />
        <LabeledInput
          label="Password"
          onChange={handleChange}
          value={state.password}
          disabled={isLoading}
          {...passwordField}
        />
        <Button success type="submit" disabled={state.isLoading}>
          {isLoading ? <Spinner /> : 'Continue'}
        </Button>
      </form>
      {error ? (
        <ErrorMessage small title={error.title} description={error.message} />
      ) : null}
      <AgreePolicyBlock preText="By logging in" />
    </FlexContainer>
  );
};

AuthLogin.displayName = 'AuthLogin';

export default AuthLogin;
